const SubAdminVerticalAccessListAccess = ({
  pathNames = [],
  backColor = "",
  parentPath=""
}) => {
  return (
    <div className="w-full flex-1 flex-col align-left justify-start g-05">
      <div className="w-full g-05 flex-row align-center justify-between">
        <span className="t-12 color-black poppins">{parentPath}</span>
        <hr color="#b0b0b0" className="w-full" />
        <div className="toggleBtn flex-row align-center justify-start">
          <span className="t-12 color-black poppins text-no-wrap">
            Access all of the {parentPath}
          </span>
          <input type="checkbox" name="allsettings" id="allsettings" />
        </div>
      </div>
      {pathNames.length > 0 &&
        pathNames.map((pathName) => {
          return (
            <div className="w-full flex-row align-center justify-between">
              <div
                className="flex-row align-center justify-center p-05 radius-6 color-white"
                style={{ background: backColor }}
              >
                {pathName}
              </div>
              <div className="toggleBtn">
                <input type="checkbox" />
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default SubAdminVerticalAccessListAccess;
